import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { filesHelper } from '@helpers';

@Component({
  selector: 'app-uploader',
  templateUrl: './uploader.component.html',
  styleUrls: ['./uploader.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: UploaderComponent,
      multi: true,
    },
  ],
})
export class UploaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hint: string;
  @Input() multiple: boolean = false;
  // See "accept" attribute in HTML input element
  @Input() accept: string;
  @Input() disabled: boolean = false;

  public files: File[] = [];
  public isDragOver = false;
  public getFileIcon = filesHelper.getFileIcon;
  public getFileSize = filesHelper.getFileSize;
  public getInvalidFiles = filesHelper.getInvalidFiles;
  public showFileTypeErrorMessage: boolean = false;

  private onChange = (files: File[]) => {};
  private onTouched = () => {};

  constructor() {}

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const droppedFiles = Array.from(event.dataTransfer?.files || []);
    this.handleFiles(droppedFiles);
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const selectedFiles = Array.from(input.files || []);
    this.handleFiles(selectedFiles);

    input.value = '';
  }

  private handleFiles(newFiles: File[]) {
    this.showFileTypeErrorMessage = false;

    if (this.accept) {
      const invalidFiles = this.getInvalidFiles(newFiles, this.accept);
      if (invalidFiles.length > 0) {
        this.showFileTypeErrorMessage = true;
        return;
      }
    }

    if (!this.multiple) {
      this.files = newFiles.slice(0, 1);
    } else {
      this.files = [...this.files, ...newFiles];
    }

    this.onChange(this.files);
    this.onTouched();
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
    this.onChange(this.files);
    this.onTouched();
  }

  writeValue(files: File[]): void {
    this.files = files || [];
  }

  registerOnChange(fn: (files: File[]) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
